import axios from 'axios';

const sendEmail = (body: any) => axios.post('https://europe-west1-agravla.cloudfunctions.net/contact', body);

export default sendEmail;
